import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  FormControl,
  Typography,
} from "@mui/material";
import typography from "../../../cssUtils/typography";
import { CallingCodeSelect } from "../../../common/country-code-select";
import { getCountryForCallingCode } from "../../../common/country-codes";
import { getPhoneValidationError } from "../../../common/phone-validation";

const SingleContact = (props) => {
  const {
    setCountryCode,
    setDialCode,
    setName,
    // Add these props to receive current values from parent
    nameValue = "",
    countryCodeValue = "",
    phoneNumberValue = "",
  } = props;

  // Initialize local state from parent values
  const [singleContactCountryCode, setSingleContactCountryCode] =
    useState(countryCodeValue);
  const [phoneNumberSuffix, setPhoneNumberSuffix] = useState(phoneNumberValue);
  const [phoneError, setPhoneError] = useState("");
  const [name, setNameLocal] = useState(nameValue);

  const [nameError, setNameError] = useState("");

    console.log("isEditMode in SingleContact:", props?.isEditMode);
  // Add effect to sync parent values to local state
  useEffect(() => {
    setNameLocal(nameValue);
    setSingleContactCountryCode(countryCodeValue);
    setPhoneNumberSuffix(phoneNumberValue);

    // Reset error states when form is cleared
    if (!nameValue && !countryCodeValue && !phoneNumberValue) {
      setNameError("");
      setPhoneError("");
    }
  }, [nameValue, countryCodeValue, phoneNumberValue]);

  // Error message for the number under the selected country, or null when valid
  const validatePhone = (countryCode, phone) =>
    countryCode
      ? getPhoneValidationError(phone, getCountryForCallingCode(countryCode), countryCode)
      : "Please select a country code.";

  const handlePhoneNumberChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setPhoneNumberSuffix(value);
    setPhoneError(validatePhone(singleContactCountryCode, value) || "");
  };

  const handleConcatenation = () => {
    if (singleContactCountryCode && !validatePhone(singleContactCountryCode, phoneNumberSuffix)) {
      setCountryCode(singleContactCountryCode);
      setDialCode(phoneNumberSuffix);
    } else {
      setCountryCode("");
      setDialCode("");
    }
  };

  // Handle first name changes and update parent component state
  const handleFirstNameChange = (e) => {
    const inputValue = e.target.value;

    setNameLocal(inputValue);
    setName(inputValue);
  };

  useEffect(() => {
    handleConcatenation();
  }, [singleContactCountryCode, phoneNumberSuffix]);

  const handleCountryCodeSelect = (value) => {
    setSingleContactCountryCode(value);
    if (phoneNumberSuffix) setPhoneError(validatePhone(value, phoneNumberSuffix) || "");
  };

  return (
    <>
      {/* First Name and Last Name Fields */}
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12}>
          <Typography sx={{ ...typography.h2, mt: 1, mb: 1 }}>
            Contact Information
          </Typography>
        </Grid>
        <Grid item xs={12}>

          <TextField
            fullWidth
            label="Name"
            variant="outlined"
            value={name}
            onChange={handleFirstNameChange}
            required
            error={nameError !== ""}
            helperText={nameError}
            disabled={props?.isEditMode}
            InputLabelProps={{
              sx: typography.bodyLarge,
            }}
            inputProps={{
              sx: typography.bodyLarge,
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '8px',
              },
              '& fieldset': {
                borderColor: '#DFE5EC',
              },
            }}
          />
        </Grid>
      </Grid>

      {/* Original Phone Number Fields */}
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} sm={3} md={4}>
          <FormControl fullWidth>
            <CallingCodeSelect
              value={singleContactCountryCode}
              onChange={handleCountryCodeSelect}
              required
              disabled={props?.isEditMode}
              TextFieldProps={{
                InputLabelProps: { sx: typography.bodyLarge },
                sx: {
                  '& .MuiOutlinedInput-root': { borderRadius: '8px', ...typography.bodyLarge },
                  '& fieldset': { borderColor: '#DFE5EC' },
                },
              }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={9} md={8}>

          <TextField
            fullWidth
            id="outlined-basic"
            label="Phone Number"
            variant="outlined"
            value={phoneNumberSuffix}
            onChange={handlePhoneNumberChange}
            required
            disabled={props?.isEditMode}
            InputLabelProps={{
              sx: typography.bodyLarge,
            }}
            inputProps={{
              sx: typography.bodyLarge,
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '8px',
              },
              '& fieldset': {
                borderColor: '#DFE5EC',
              },
            }}
          />
        </Grid>
        {phoneError && (
          <Typography
            color="error"
            sx={{
              ...typography.bodySmall,
              display: "block",
              mt: 1,
              ml: 1,
              color: "#d32f2f",
            }}
          >
            {phoneError}
          </Typography>
        )}
      </Grid>
    </>
  );
};

export default SingleContact;